import { Loader } from '@mantine/core';
import { useFileManager } from 'api/file-manager/file-manager-context';
import panic from 'errors/panic';
import { useEffect, useState } from 'react';
import { SpecialZoomLevel, Viewer, Worker } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';

import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';

interface PDFDisplayProps {
  fileId: string;
  fileName: string;
}

/**
 * Displays PDF in <iframe>.
 */
export default function PDFDisplay({ fileId, fileName }: PDFDisplayProps) {
  const { createTimeAccessToken, buildTimeAccessFileUrl } = useFileManager();
  const [url, setUrl] = useState('');
  const defaultLayoutPluginInstance = defaultLayoutPlugin({
    toolbarPlugin: {
      getFilePlugin: {
        fileNameGenerator: () => fileName,
      },
    },
  });

  useEffect(() => {
    createTimeAccessToken({ fileId, validForMinutes: 60 })
      .then((token) => setUrl(buildTimeAccessFileUrl({ token, fileName })))
      .catch(panic);
  }, [fileId, fileName, createTimeAccessToken, buildTimeAccessFileUrl]);

  if (!url) {
    return <Loader />;
  }

  return (
    <div className="h-[calc(100%-20px)] w-full">
      <Worker workerUrl="/js/pdf.worker.js">
        <Viewer fileUrl={url} plugins={[defaultLayoutPluginInstance]} defaultScale={SpecialZoomLevel.PageFit} />
      </Worker>
    </div>
  );
}
